import { useCallback, useRef, useState } from 'react'

import type { DebounceFunction } from 'src/hooks/useDebounce/types'

export const useDebounce = <T extends unknown[]>(
  callback: DebounceFunction<T>,
  delay: number,
) => {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const timeoutIdRef = useRef<NodeJS.Timeout | null>(null)

  const debouncedFn: DebounceFunction<T> = useCallback(
    (...args: T) => {
      setIsLoading(true)

      if (timeoutIdRef.current) {
        clearTimeout(timeoutIdRef.current)
      }

      timeoutIdRef.current = setTimeout(() => {
        callback(...args)
        setIsLoading(false)
      }, delay)
    },
    [callback, delay],
  )

  return { callback: debouncedFn, isLoading }
}
